import { Box } from "@mui/material";

const SidebarBodyContent = ({ children, sx, py = 3, px = 2 }) => {
  return <Box sx={{ px, py, ...sx }}>{children}</Box>;
};

export default SidebarBodyContent;
